import { SideMenu } from "../components/SideMenu/SideMenu.jsx";
import { DashboardPage, createDashboardLayout } from "../components/DashboardPage/DashboardPage.jsx";
import { HelpTipsPane } from "../features/help/HelpTipsPane.jsx";
import { HelpShortcutsPane } from "../features/help/HelpShortcutsPane.jsx";
import { APP_VERSION } from "../lib/version.js";

export const defaultHelpSection = "shortcuts";
const helpSectionItems = [
  {
    value: "shortcuts",
    labelKey: "shortcuts",
    descriptionKey: "navigation.help.shortcuts"
  },
  {
    value: "tips",
    labelKey: "navigation.help.tips",
    descriptionKey: "navigation.help.tipsDescription"
  }
];

const helpPageLayout = createDashboardLayout({
  columns: [
    { size: "fixed", value: "var(--app-side-menu-width)" },
    { size: "fill" }
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["sections", "content"]
  ]
});

export function HelpPage({
  activeSection,
  getTranslationNode = () => null,
  onSectionChange,
  showAltHints = false,
  t = (key) => key,
  activeLanguage
}) {
  const content = activeSection === "tips"
    ? <HelpTipsPane getTranslationNode={getTranslationNode} t={t} />
    : <HelpShortcutsPane t={t} activeLanguage={activeLanguage} />;
  const sectionItems = helpSectionItems.map((item) => ({
    ...item,
    label: t(item.labelKey),
    description: t(item.descriptionKey)
  }));

  return (
    <DashboardPage
      layout={helpPageLayout}
      slots={[
        {
          key: "sections",
          area: "sections",
          content: (
            <SideMenu
              items={sectionItems}
              value={activeSection}
              onChange={onSectionChange}
              showAltHints={showAltHints}
              focusBinding="Alt+S"
              footer={`${t("version")} ${APP_VERSION}`}
            />
          )
        },
        {
          key: "content",
          area: "content",
          content
        }
      ]}
    />
  );
}
